import React from "react"

import {
    Form,
    Row,
    Col,
} from "react-bootstrap"

import "./style.css"

const localeDate = (date: Date) => {
    const currentYear = date.getFullYear()
    const currentMonth = date.getMonth() + 1
    const currentDay = date.getDate()
    
    return `${currentYear}-${currentMonth < 10 ? `0${currentMonth}` : currentMonth}-${currentDay < 10 ? `0${currentDay}` : currentDay}`
}


const DateSelection = (props) => {
    const { 
        setStartDate, 
        setEndDate, 
        initialStartDate, 
        initialEndDate
    } = props
  
    const maxDate = localeDate(new Date())
    return (
        <Form className="text-light">
            <Form.Group as={Row}>
                <Form.Group as={Col} className="mb-3">
                    <Form.Label htmlFor="start">Start date:</Form.Label>
                    <Form.Control 
                        type="date" 
                        id="start" 
                        name="date-start"
                        onChange={(e) => setStartDate(e.target.value)}
                        max={maxDate} 
                        defaultValue={initialStartDate ? localeDate(initialStartDate) : ""}
                    />
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label htmlFor="end">End date:</Form.Label>
                    <Form.Control
                        type="date" 
                        id="end" 
                        name="date-end"
                        onChange={(e) => setEndDate(e.target.value)}
                        max={maxDate} 
                        defaultValue={initialEndDate ? localeDate(initialEndDate) : ""}
                    />
                </Form.Group>
            </Form.Group>
        </Form>
    )
}

export default DateSelection